import { useTranslation } from "react-i18next";

import DefaultActions from "./DefaultActions";

export default function ExamActions({
	row,
	onPrimary,
	menuActions = null,
	primaryText = undefined,
	renderStats = null,
	isLoading = false,
}) {
	const { t } = useTranslation();

	return (
		<DefaultActions
			renderStats={renderStats}
			ActionsList={menuActions}
			onPrimary={onPrimary}
			isLoading={isLoading}
			menuButtonTestId={`exam-menu-button-${row.id}`}
			primaryText={
				primaryText ||
				(row.status === "active" ? t("commands.resume") : t("commands.watch"))
			}
		/>
	);
}
